module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"message":"弊社スタッフよりご連絡させていただきますので、\\n今しばらくお待ちくださいませ。","toTop":"{label}にもどる"}}')
  delete Component.options._Ctor
}
